import { PndType, SourceType } from "@/enums/enums";
import { SearchWhtCertificateModel } from "@/model/table/tableViewModel";
import { GetFileType } from "@/helper/shareHelper";

export function ConvertToWhtCertificateDetail(_whtCertificateDetail: any, contactList: any) {
  const contact = contactList.find((x: any) => x.id == _whtCertificateDetail.contactId);
  const whtCertificateDetail = {
    whtNumber: _whtCertificateDetail.whtNumber,
    whtDate: _whtCertificateDetail.whtDate,
    conditionType: _whtCertificateDetail.conditionType,
    referenceOne: _whtCertificateDetail.referenceOne,
    referenceTwo: _whtCertificateDetail.referenceTwo,
    contactId: contact.id,
    contactCode: contact.contactCode,
    contactType: contact.contactType,
    contactTaxId: contact.contactTaxId,
    contactFullName: contact.contactFullName,
    contactBranchCode: contact.contactBranchCode,
    contactAddress: contact.address,
    paymentFlowType: _whtCertificateDetail.paymentFlowType,
    pndType: _whtCertificateDetail.pndType,
    subTotal: _whtCertificateDetail.subTotal,
    whtTotal: _whtCertificateDetail.whtTotal,
    pensionFundAmount: _whtCertificateDetail.pensionFundAmount,
    socialSecurityAmount: _whtCertificateDetail.socialSecurityAmount,
    providentFundAmount: _whtCertificateDetail.providentFundAmount,
    status: _whtCertificateDetail.status,
    sourceType: _whtCertificateDetail.sourceType,
    sourceId: _whtCertificateDetail.sourceId,
    id: _whtCertificateDetail.id,
    isDeleted: _whtCertificateDetail.isDeleted,
    pndNumber: _whtCertificateDetail.pndNumber,
    pndId: _whtCertificateDetail.pndId,
    whtItemModelList: [] as any,
  };

  if (_whtCertificateDetail.whtItemModelList && _whtCertificateDetail.whtItemModelList.length > 0) {
    _whtCertificateDetail.whtItemModelList.forEach((whtItemModel: any) => {
      whtCertificateDetail.whtItemModelList.push({
        whtRate: whtItemModel.whtRate,
        whtAmount: whtItemModel.whtAmount,
        preTaxAmount: whtItemModel.preTaxAmount,
        taxIncomeType: whtItemModel.taxIncomeType,
        description: whtItemModel.description,
        whtItemId: whtItemModel.whtItemId,
        whtCertificateId: whtItemModel.whtCertificateId,
      });
    });
  }

  return whtCertificateDetail;
}

export function GetContactIdListForPrepareWithholdingTax(withholdingTaxList: Array<any>) {
  const contactIdList: Array<number> = [];

  if (withholdingTaxList && withholdingTaxList.length > 0) {
    withholdingTaxList.forEach((withholdingTax: any) => {
      if (withholdingTax.contactId > 0) {
        contactIdList.push(withholdingTax.contactId);
      }
    });
  }

  return contactIdList;
}

export function ConvertToWithholdingTaxTableAdvanceSearch(withholdingTaxList: Array<any>, contactList: Array<any>) {
  const withholdingTaxTableList: any = [];

  if (withholdingTaxList && withholdingTaxList.length > 0) {
    withholdingTaxList.forEach((withholdingTax: any) => {
      let contact = null;
      const getContactbyId = contactList.find((x) => x.id == withholdingTax.contactId);
      if (getContactbyId) {
        contact = {
          contactBranchCode: getContactbyId.contactBranchCode,
          contactCode: getContactbyId.contactCode,
          contactFullName: getContactbyId.contactFullName,
          contactName: getContactbyId.contactName,
          contactId: getContactbyId.id,
          contactTaxId: getContactbyId.contactTaxId,
          contactType: getContactbyId.contactType,
        };
      }
      withholdingTaxTableList.push({
        id: withholdingTax.id,
        whtNumber: withholdingTax.whtNumber,
        pndType: withholdingTax.pndType,
        sourceType: withholdingTax.sourceType,
        isDeleted: withholdingTax.isDeleted,
        sourceId: withholdingTax.sourceId,
        whtDate: withholdingTax.whtDate,
        description: withholdingTax.description,
        subTotal: withholdingTax.subTotal,
        whtTotal: withholdingTax.whtTotal,
        status: withholdingTax.status,
        contact: contact,
      });
    });
  }

  return withholdingTaxTableList;
}

export function ConvertToSearchWithholdingTaxRequest(searchWhtCertificate: any) {
  const searchWithholdingTaxRequest: SearchWhtCertificateModel = {
    whtNumber: searchWhtCertificate.documentNumber ? searchWhtCertificate.documentNumber : "",
    fromDate: searchWhtCertificate.fromDate,
    toDate: searchWhtCertificate.toDate,
    contactId: searchWhtCertificate.contactId ? searchWhtCertificate.contactId : 0,
    pndType: searchWhtCertificate.pndTypeId,
    fromSubTotal: searchWhtCertificate.fromSubTotal ? searchWhtCertificate.fromSubTotal.ToNumber() : null,
    toSubTotal: searchWhtCertificate.toSubTotal ? searchWhtCertificate.toSubTotal.ToNumber() : null,
    fromWhtTotal: searchWhtCertificate.fromVatTotal ? searchWhtCertificate.fromVatTotal.ToNumber() : null,
    toWhtTotal: searchWhtCertificate.toVatTotal ? searchWhtCertificate.toVatTotal.ToNumber() : null,
    referenceNumberOne: searchWhtCertificate.referenceNumber ? searchWhtCertificate.referenceNumber : "",
    referenceNumberTwo: searchWhtCertificate.referenceNumberTwo ? searchWhtCertificate.referenceNumberTwo : "",
    sourceTypeId: searchWhtCertificate.sourceTypeId,
  };
  return searchWithholdingTaxRequest;
}

export function ConvertToFileStorageWhtCertificate(fileStorageWhtCertificateList: Array<any>) {
  const fileStorageWhtCertificate: any = [];

  if (fileStorageWhtCertificateList.length > 0) {
    fileStorageWhtCertificateList.forEach((item: any) => {
      fileStorageWhtCertificate.push({
        createDateTime: item.uploadDateTime,
        fileFullUrl: item.fileUrl,
        fileName: item.fileName,
        name: item.fileName,
        fileType: item.fileContentType ? item.fileContentType : GetFileType(item.fileName),
        id: item.fileId,
        userId: item.uploadUserId,
      });
    });
  }
  return fileStorageWhtCertificate;
}

export function ConvertToCommentLogWhtCertificate(_commentList: Array<any>) {
  const commentList: any = [];

  if (_commentList.length > 0) {
    _commentList.forEach((item: any) => {
      commentList.push({
        actionDateTime: item.actionDateTime,
        actionUserId: item.actionUserId,
        commentId: item.commentId,
        commentLogType: item.commentLogType,
        data: item.data,
        note: item.note,
      });
    });
  }
  return commentList;
}
